import { JsonStorage } from "@next-core/utils/general";
// Themes.
let theme = "light";
const storage = new JsonStorage(localStorage);
const LOCAL_STORAGE_APPS_THEME_KEY = "apps-theme";
export function setTheme(value) {
  if (value !== "dark" && value !== "light" && value !== "dark-v2") {
    throw new Error(`Unsupported theme: ${value}`);
  }
  theme = value;
}
export function getTheme() {
  return theme;
}
export function getCurrentTheme() {
  return document.documentElement.dataset.theme;
}
export function applyTheme(value) {
  if (value) {
    setTheme(value);
  } else {
    value = getTheme();
  }
  if (value !== getCurrentTheme()) {
    document.documentElement.dataset.theme = value;
    window.dispatchEvent(new CustomEvent("theme.change", {
      detail: value
    }));
  }
}
export function batchSetAppsLocalTheme(appsTheme) {
  storage.setItem(LOCAL_STORAGE_APPS_THEME_KEY, {
    ...getLocalAppsTheme(),
    ...appsTheme
  });
}
export function getLocalAppsTheme() {
  let result;
  try {
    result = storage.getItem(LOCAL_STORAGE_APPS_THEME_KEY);
  } catch {
    // eslint-disable-next-line no-console
    console.error("JSON parse error inside `getLocalAppsTheme()`");
  }
  return result !== null && result !== void 0 ? result : {};
}

// Modes.
let mode = "default";
export function setMode(value) {
  if (value !== "dashboard" && value !== "default") {
    throw new Error(`Unsupported mode: ${value}`);
  }
  mode = value;
}
export function getMode() {
  return mode;
}
export function getCurrentMode() {
  return document.documentElement.dataset.mode;
}
export function applyMode(value) {
  if (value) {
    setMode(value);
  } else {
    value = getMode();
  }
  if (value !== getCurrentMode()) {
    document.documentElement.dataset.mode = value;
    window.dispatchEvent(new CustomEvent("mode.change", {
      detail: value
    }));
  }
}
export function getCssPropertyValue(name) {
  var _window$getComputedSt;
  let el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
  if (!el) return "";
  return ((_window$getComputedSt = window.getComputedStyle(el)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.getPropertyValue(name)) || "";
}
let variant = "default";
export function setThemeVariant(value) {
  if (value !== "default" && value !== "elevo") {
    return setThemeVariant("default");
  }
  if (variant === value) {
    return;
  }
  document.documentElement.dataset.variant = variant = value;
  window.dispatchEvent(new CustomEvent("variant.change", {
    detail: value
  }));
}
export function getThemeVariant() {
  return variant;
}
//# sourceMappingURL=themeAndMode.js.map